
export const themes = {
  light: {
    colors: {
      primary: '#157f75ff',
      primaryHover: '#0f766e',
      primaryDark: '#115e59',
      primaryLight: '#f0fdfa',
      textPrimary: '#111827',
      textSecondary: '#4b5563',
      textMuted: '#6b7280',
      borderColor: '#e5e7eb',
      bgCard: '#ffffff',
      bgInput: '#ffffff',
      bgMain: 'linear-gradient(135deg, #E0F2F1 0%, #FFFFFF 100%)',
      bgPage: '#f8fafc',
      headerBg: '#ffffff',
      sidebarBg: 'linear-gradient(180deg, #0f766e 0%, #115e59 100%)',
      sidebarText: '#ffffff',
      shadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    },
    vars: {
      '--bg-main': 'linear-gradient(135deg, #E0F2F1 0%, #FFFFFF 100%)',
      '--bg-page': '#f8fafc',
      '--bg-card': '#ffffff',
      '--bg-input': '#ffffff',
      '--primary': '#0d9488',
      '--primary-hover': '#0f766e',
      '--primary-dark': '#115e59',
      '--primary-light': '#f0fdfa',
      '--text-primary': '#111827',
      '--text-secondary': '#4b5563',
      '--text-muted': '#6b7280',
      '--border-color': '#e5e7eb',
      '--shadow': '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
      '--header-bg': '#ffffff',
      '--sidebar-bg': 'linear-gradient(180deg, #0f766e 0%, #115e59 100%)',
      '--sidebar-text': '#ffffff',
    }
  },
  dark: {
    colors: {
      primary: '#2dd4bf',
      primaryHover: '#5eead4',
      primaryDark: '#0d9488',
      primaryLight: '#134e4a',
      textPrimary: '#f8fafc',
      textSecondary: '#94a3b8',
      textMuted: '#64748b',
      borderColor: '#334155',
      bgCard: '#1e293b',
      bgInput: '#0f172a',
      bgMain: '#020617',
      bgPage: '#020617',
      headerBg: '#1e293b',
      sidebarBg: '#0f172a',
      sidebarText: '#f8fafc',
      shadow: '0 10px 15px -3px rgb(0 0 0 / 0.3), 0 4px 6px -4px rgb(0 0 0 / 0.3)',
    },
    vars: {
      '--bg-main': '#020617',
      '--bg-page': '#020617',
      '--bg-card': '#1e293b',
      '--bg-input': '#0f172a',
      '--primary': '#2dd4bf',
      '--primary-hover': '#5eead4',
      '--primary-dark': '#0d9488',
      '--primary-light': '#134e4a',
      '--text-primary': '#f8fafc',
      '--text-secondary': '#94a3b8',
      '--text-muted': '#64748b',
      '--border-color': '#334155',
      '--shadow': '0 10px 15px -3px rgb(0 0 0 / 0.3), 0 4px 6px -4px rgb(0 0 0 / 0.3)',
      '--header-bg': '#1e293b',
      '--sidebar-bg': '#0f172a',
      '--sidebar-text': '#f8fafc',
    }
  },
  standard: {
    colors: {
      primary: '#334155',
      primaryHover: '#1e293b',
      primaryDark: '#0f172a',
      primaryLight: '#f1f5f9',
      textPrimary: '#0f172a',
      textSecondary: '#475569',
      textMuted: '#64748b',
      borderColor: '#cbd5e1',
      bgCard: '#ffffff',
      bgInput: '#f8fafc',
      bgMain: '#f1f5f9',
      bgPage: '#f1f5f9',
      headerBg: '#ffffff',
      sidebarBg: '#1e293b',
      sidebarText: '#ffffff',
      shadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    },
    vars: {
      '--bg-main': '#f1f5f9',
      '--bg-page': '#f1f5f9',
      '--bg-card': '#ffffff',
      '--bg-input': '#f8fafc',
      '--primary': '#334155',
      '--primary-hover': '#1e293b',
      '--primary-dark': '#0f172a',
      '--primary-light': '#f1f5f9',
      '--text-primary': '#0f172a',
      '--text-secondary': '#475569',
      '--text-muted': '#64748b',
      '--border-color': '#cbd5e1',
      '--shadow': '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
      '--header-bg': '#ffffff',
      '--sidebar-bg': '#1e293b',
      '--sidebar-text': '#ffffff',
    }
  }
};
